import React from "react";
import DashboardIcon from "@material-ui/icons/Dashboard";
import KeyboardIcon from "@material-ui/icons/Keyboard";
import KeyboardVoiceIcon from "@material-ui/icons/KeyboardVoice";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import ExitToApp from "@material-ui/icons/ExitToApp";
import logo from "./../../assets/img/logo2.png";
import KeyboardHideIcon from "@material-ui/icons/KeyboardHide";
import AssessmentIcon from "@material-ui/icons/Assessment";
import GraphicEqIcon from "@material-ui/icons/GraphicEq";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import SurroundSoundIcon from "@material-ui/icons/SurroundSound";
import SettingsOverscanIcon from "@material-ui/icons/SettingsOverscan";
import Tooltip from "@material-ui/core/Tooltip";
import { matchPath, withRouter } from "react-router";
import { connect } from "react-redux";
class LeftNav extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    console.log(
      "Test data",
      this.props.propValue.userLogin.loggedUser.userType
    );
    return (
      <div className="left-nav">
        <div className="left-nav-wrapper">
          <div className="logo">
            <img src={logo} width="140" height="140" alt="logo" />
          </div>
          <ul className="menus">
            <li>
              <Tooltip title="Dashboard">
                <a
                  href=""
                  onClick={() => this.props.handleNavigation("dashboard")}
                  className={
                    matchPath(this.props.location.pathname, {
                      path: "/dashboard",
                    })
                      ? "menuitem active"
                      : "menuitem"
                  }
                >
                  <DashboardIcon />
                </a>
              </Tooltip>
            </li>
            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "1"
            ) ? (
              <li>
                <Tooltip title="Audio Transcription">
                  <a
                    href=""
                    onClick={() => this.props.handleNavigation("audio-trans")}
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/audio-trans",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <AudiotrackIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}
            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "2"
            ) ? (
              <li>
                <Tooltip title="Audio Recording">
                  <a
                    href=""
                    onClick={() => this.props.handleNavigation("audio-record")}
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/audio-record",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <KeyboardVoiceIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}
            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "3"
            ) ? (
              <li>
                <Tooltip title="Transcript Audit">
                  <a
                    href=""
                    onClick={() => this.props.handleNavigation("transAduit")}
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/transAduit",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <GraphicEqIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}
            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "4"
            ) ? (
              <li>
                <Tooltip title="Super Admin">
                  <a
                    href=""
                    onClick={() => this.props.handleNavigation("sa-dashboard")}
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/sa-dashboard",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <SettingsOverscanIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}
            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "5"
            ) ? (
              <li>
                <Tooltip title="Audio Audit">
                  <a
                    href=""
                    onClick={() => this.props.handleNavigation("audioAduit")}
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/audioAduit",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <SurroundSoundIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}
            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "7"
            ) ? (
              <li>
                <Tooltip title="Keyword Generation">
                  <a
                    href=""
                    onClick={() =>
                      this.props.handleNavigation("keyword-generate")
                    }
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/keyword-generate",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <KeyboardIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}

            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "6"
            ) ? (
              <li>
                <Tooltip title="Super Audio Audit">
                  <a
                    href=""
                    onClick={() => this.props.handleNavigation("sqa-dasboard")}
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/sqa-dasboard",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <EqualizerIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}
            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "8"
            ) ? (
              <li>
                <Tooltip title="Keyword Audit">
                  <a
                    href=""
                    onClick={() => this.props.handleNavigation("keyword-audit")}
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/keyword-audit",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <KeyboardHideIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}

            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "9"
            ) ? (
              <li>
                <Tooltip title="Report">
                  <a
                    href=""
                    onClick={() => this.props.handleNavigation("report")}
                    className={
                      matchPath(this.props.location.pathname, {
                        path: "/report",
                      })
                        ? "menuitem active"
                        : "menuitem"
                    }
                  >
                    <AssessmentIcon />
                  </a>
                </Tooltip>
              </li>
            ) : null}
            {this.props.propValue.userLogin.loggedUser.userType.includes(
              "10"
            ) ? (
              <>
                <li>
                  <Tooltip title="Super Transcript Audit">
                    <a
                      href=""
                      onClick={() =>
                        this.props.handleNavigation("super-transcript-audit")
                      }
                      className={
                        matchPath(this.props.location.pathname, {
                          path: "/super-transcript-audit",
                        })
                          ? "menuitem active"
                          : "menuitem"
                      }
                    >
                      <GraphicEqIcon />
                    </a>
                  </Tooltip>
                </li>
                <li>
                  <Tooltip title="Keyword Creation">
                    <a
                      href=""
                      onClick={() =>
                        this.props.handleNavigation("keyword-create")
                      }
                      className={
                        matchPath(this.props.location.pathname, {
                          path: "/keyword-create",
                        })
                          ? "menuitem active"
                          : "menuitem"
                      }
                    >
                      <KeyboardIcon />
                    </a>
                  </Tooltip>
                </li>
              </>
            ) : null}
            {/* {loggedUser.userType === '1' ? (
            <li>
              <a
                href=''
                onClick={() => props.handleNavigation('audio-record')}
                className={
                    matchPath(this.props.location.pathname, {
                      path: '/dashboard',
                    })
                      ? 'menuitem active'
                      : 'menuitem'
                  }
              >
                <KeyboardVoiceIcon />
              </a>
            </li>
          ) : null} */}
            <li style={{ width: "30px" }}>
              <a
                onClick={(e) => [e.preventDefault(), this.props.exitApp()]}
                href=""
                className="menuitem"
                title="LOGOUT"
              >
                <ExitToApp />
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
  //  }
}

// const mapStateToProps = (state) => {
//   //console.log(state)
//   const { AudioToTrackReducer, userLogin, page } = state;
//   return {
//     AudioToTrackReducer,
//     userLogin,
//     page,
//   };
// };

export default withRouter(LeftNav);
